import { Typography, IconButton, Box } from "@material-ui/core";

import SemImagemSmall from "assets/images/sem-imagem-small.jpg";

import { PreTestIcon } from "./PreTestIcon";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

export const KnowledgeAssessmentCard = ({}) => {
  return (
    <div className="knowledge-assessment-card">
      {/* Icone principal */}
      <Box className="knowledge-assessment-card-icon">
        <img
          alt="article"
          className="node-manager-content-type-article-image"
          src={SemImagemSmall}
        />
      </Box>

      <Box style={{ flex: 1 }}>
        {/* Título e subtítulo */}
        {/* {!hasKnowledgementTest && (
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {title}
          </Typography>
        )} */}
        <Typography
          variant="subtitle2"
          color="textSecondary"
          style={{ display: "flex", alignItems: "center" }}
        >
          <PreTestIcon />
          Pré-teste de conhecimento
        </Typography>

        {/* Descrição */}
        <span className="knowledge-assessment-card-description">
          O pré-teste é obrigatório e será a primeira etapa ao acessar a página. O conteúdo só será
          liberado após a conclusão da avaliação.
        </span>
      </Box>

      {/* Botões de ação */}
      {/* {!hasKnowledgementTest && (
        <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <IconButton aria-label="editar">
            <EditIcon />
          </IconButton>
          <IconButton aria-label="remover">
            <DeleteIcon />
          </IconButton>
        </Box>
      )} */}
    </div>
  );
};
